import React from "react";
import { Card } from "./ui/card.jsx";
import { AnimatedSection } from "./IntersectionObserver.tsx";
import { Search, Palette, Code, Link, BarChart, TrendingUp } from "lucide-react";

interface Service {
  title: string;
  description: string;
  icon: React.ReactNode;
}

const Services: React.FC = () => {
  const services: Service[] = [
    {
      title: "Стратегия и аудит",
      description: "JTBD, воронки, карта контента, KPI.",
      icon: <Search size={48} />
    },
    {
      title: "Дизайн и дизайн-система",
      description: "Арт-направление, дизайн-система, анимации, a11y.",
      icon: <Palette size={48} />
    },
    {
      title: "Разработка (Headless/.NET/JS)",
      description: "SSR/ISR, PWA, мини-CMS для редакторов.",
      icon: <Code size={48} />
    },
    {
      title: "Интеграции",
      description: "ERP/CRM (SAP B1), платежи (Adyen/Stripe), OMS/WMS, DAM, CDP.",
      icon: <Link size={48} />
    },
    {
      title: "SEO",
      description: "Бюджет CWV, схемы, мультирегиональность.",
      icon: <BarChart size={48} />
    },
    {
      title: "CRO и рост",
      description: "A/B тестирование, персонализация, e-mail/SMS, аналитика.",
      icon: <TrendingUp size={48} />
    }
  ];

  return (
    <section id="services" className="services-section pad-xlarge">
      <div className="dark-container">
        <AnimatedSection>
          <div className="section-header">
            <h2 className="display-medium">Что мы делаем</h2>
          </div>
        </AnimatedSection>

        <div className="dark-grid">
          {services.map((service: Service, index: number) => (
            <AnimatedSection key={index} delay={index + 1}>
              <Card className="service-card dark-hover">
                <div className="service-icon">{service.icon}</div>
                <h3 className="heading-2">{service.title}</h3>
                <p className="body-medium service-description">
                  {service.description}
                </p>
              </Card>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;